export default "__VITE_ASSET__DdpoVG9q__"